import routeConfige from "../../../../app/providers/router/config";
import { getStyle } from "../../../../shared/helper/getStyles";
import useAppRoutes from "../../../../shared/hooks/useAppRoutes";
import AppNavLink from "../AppNavLink/AppNavLink";
import styles from './NavbarDesktop.module.scss';

const NavbarDesktop = ({className}) => {
    const routes = useAppRoutes({routeConfige});
    
    const additional = [
        className,
    ]
    return ( 
        <div className={styles.container}>
            <nav className={getStyle(styles.navbar, {}, additional)}>
                {
                    routes.map(route => (
                        <AppNavLink
                            key={route.path}
                            route={route}
                            styles={styles}
                        >
                        </AppNavLink>
                    ))
                }
            </nav>
        </div>
    );
}

export default NavbarDesktop;